
import React, { Suspense } from 'react';
import { Spinner, Center } from '@chakra-ui/react';
const Hero = React.lazy(() => import('../Components/Home/Hero'));
const Overview = React.lazy(() => import('../Components/Home/Overview'));
const VisionMission = React.lazy(() => import('../Components/Home/VisionMission'));
const Businesses = React.lazy(() => import('../Components/Home/Services')); 
const Careers = React.lazy(() => import('../Components/Home/Careers'));
const Contact = React.lazy(() => import('../Components/Home/Contact'));
const ScrollToTopButton = React.lazy(() => import('../Components/ScrollToTopButton'));

const Home = () => {
  const mainColor = '#3D53A4'; 

  return (
    <>
      <Suspense
        fallback={
          <Center height="100vh">
            <Spinner
              thickness="4px"
              speed="0.65s"
              emptyColor="gray.200"
              color={mainColor}
              size="xl"
            />
          </Center>
        }
      >
        <Hero />
        <Overview />
        <VisionMission />
        <Businesses />
        <Careers />
        <Contact />
        <ScrollToTopButton />
      </Suspense>
    </>
  );
};

export default Home;
